// CSpell:ignore UNSTARTED

export enum AutoplayMode {
  Unset,
  Playing,
  Pausing,
}

export enum PlayerState {
  UNSTARTED = -1,
  ENDED = 0,
  PLAYING = 1,
  PAUSED = 2,
  BUFFERING = 3,
  CUED = 5,
}
